import { ApiData } from "../../data/apiData";
import { PasswordRequirements } from "../../data/passwordRequirements";
import { ProductData } from "../../data/productData";
import { PreApprovedSolutionData } from "../../data/preApprovedSolutionData";
import IConfigService from "../../services/config/IConfigService";
import { DiTokens } from "../../services/diTokens";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";
import { Curs, Curses } from "../../data/currencyRates";

@Module({
  name: "config",
  namespaced: true
})
export class ConfigStore extends VuexModule {
  get configService(): IConfigService {
    return container.get<IConfigService>(DiTokens.ConfigService);
  }

  get windowWidth(): number {
    return window.innerWidth;
  }

  /**Данные Api */
  public apiData: ApiData = new ApiData();

  public operationCodesWithAlertSuccessState: Array<string> = [];

  /**Требования к паролю */
  public passwordRequirements: PasswordRequirements = new PasswordRequirements();

  public products: Array<ProductData> = [];

  public preApprovedSolutionData: PreApprovedSolutionData[] = [];


  public quiqOperations: Array<ProductData> = [];

  public isHiddenItemsVissible: boolean =
    document.cookie.indexOf("showHiddenItems=true") >= 0;

  public isClosedItemsVissible: boolean =
    document.cookie.indexOf("showClosedItems=true") >= 0;
  
  public isRestHiddenVissible: boolean =
    document.cookie.indexOf("showRestHiddens=true") >= 0;

  public loading: boolean = true;

  public currencyLoading: boolean = true;

  public currencyRates: Curses | null = null;

  @Mutation
  setShowRestVisibility(visibility: boolean) {
    this.isRestHiddenVissible = visibility;
    document.cookie = this.isRestHiddenVissible
      ? "showRestHiddens=true"
      : "showRestHiddens=false";
  }

  @Mutation
  setItemsVisibility(visibility: boolean) {
    this.isHiddenItemsVissible = visibility;
    document.cookie = this.isHiddenItemsVissible
      ? "showHiddenItems=true"
      : "showHiddenItems=false";
  }

  @Mutation
  setClosedItemsVisibility(visibility: boolean) {
    this.isClosedItemsVissible = visibility;
    document.cookie = this.isClosedItemsVissible
      ? "showClosedItems=true"
      : "showClosedItems=false";
  }

  @Mutation
  setLoading(val: boolean) {
    this.loading = val;
  }

  @Mutation
  setApiData(apiData: ApiData) {
    this.apiData = apiData;
    this.operationCodesWithAlertSuccessState = [apiData.OperationCodeOfCreditRequest, apiData.OperationCodeOfOpenDeposit];
  }

  @Mutation
  setCurrencyLoading(loading: boolean) {
    this.currencyLoading = loading;
  }

  @Mutation
  setCurrencyRates(rates: Curses) {
    this.currencyRates = rates;
  }

  @Mutation
  setProducts(products: Array<ProductData>) {
    this.products = products;
  }

  @Mutation
  setPreApprovedSolutionDataArray(data: PreApprovedSolutionData[]) {
    this.preApprovedSolutionData = data;
  }

  @Mutation
  clearPreApprovedSolutionData() {
    this.preApprovedSolutionData = [];
  }
  
  @Mutation
  setQuiqOperations(products: Array<ProductData>) {
    this.quiqOperations = products;
  }

  @Mutation
  setPasswordRequirements(passwordRequirements: PasswordRequirements) {
    this.passwordRequirements = passwordRequirements;
  }

  /**Заполнение данных api */
  @Action
  public async fetchApiState() {
    this.setLoading(true);
    const apiData = await this.configService.fetchApiState();
    this.setApiData(apiData);
    this.setLoading(false);
  }

  /**
   * Загрузка требований к паролю
   * @returns Требования к паролю
   */
  @Action
  public async fetchPasswordRequirements() {
    this.setLoading(true);
    const passwordRequirements = await this.configService.fetchPasswordRequirements();
    this.setPasswordRequirements(passwordRequirements);
    this.setLoading(false);
  }

  @Action
  /**Заполнение предложений банка */
  public async fetchProducts() {
    this.setLoading(true);
    const products = await this.configService.getProductsAsync(
      this.apiData.ProductsFile
    );
    this.setProducts(products);
    this.setLoading(false);
  }

  @Action
  /**Заполнение предложений банка */
  public async fetchQuiqOperationsAsync() {
    this.setLoading(true);
    const products = await this.configService.getQuiqOperationsAsync(
      this.apiData.QuickOperationsFile
    );
    this.setQuiqOperations(products);
    this.setLoading(false);
  }

  @Action
  public async fetchCurenccyRates() {
    this.setCurrencyLoading(true);
    const curses: Curses = await this.configService.getCurrencyRatesAsync('810');
    this.setCurrencyRates(curses);
    this.setCurrencyLoading(false);
  }
}
